import React, { useEffect, useState } from 'react';

import { getVersion } from '../api/version/version';
import { versions } from '@helios/frontend-core';

export const useGetVersions = () => {
  const appVersion = versions.getAppVersion();
  const [apiVersion, setApiVersion] = useState<string>();
  const [binaryVersion, setBinaryVersion] = useState<React.ReactText>();

  useEffect(() => {
    (async () => {
      setBinaryVersion(await versions.getBinaryVersion());
      setApiVersion(await getVersion());
    })();
  }, []);

  return {
    appVersion,
    apiVersion,
    binaryVersion,
  };
};
